import { Dispatch } from 'redux';
import { execute } from './execute';
import localStorageConstants, { getFromLocalStorage } from '../constants/localstorage';

type TypeEvent =
  | 'HOME'
  | 'BTN_DENUNCIA'
  | 'BTN_SEGUIMIENTO_DENUNCIA'
  | 'BTN_LINEAMIENTOS_ETICA'
  | 'BTN_PREGUNTAS_FRECUENTES'
  | 'BTN_ENVIAR_DENUNCIA'
  | 'BTN_INGRESAR'
  | 'BTN_ENVIAR_COMENTARIO'
  | 'BTN_INFO_ACTOS_SOBORNO'
  | 'BTN_INFO_ACOSO_LABORAL'
  | 'BTN_INFO_ACOSO_SEXUAL'
  | 'BTN_INFO_CONFLICTO_INTERES'
  | 'BTN_DENUNCIA_COPIAR'
  | 'BTN_DENUNCIA_REGRESAR'
  | 'SEGUIMIENTO_DENUNCIA';

export interface GetEventsParams {
  fechaInicio?: string;
  fechaFin?: string;
  event?: string; // comma-separated for multiple events
}

export type IGetEventsResponse = {
  event: TypeEvent;
  total: number;
  description: string;
}[];

const PAGE_VIEW_EVENTS: TypeEvent[] = ['HOME', 'SEGUIMIENTO_DENUNCIA'];

const analyticsService = {
  sendEvent: async (event: TypeEvent) => {
    if (PAGE_VIEW_EVENTS.includes(event)) {
      const isRegistered = sessionStorage.getItem(`event_registered_${event}`);
      if (isRegistered) return [];
    }

    try {
      const resp = await execute({
        method: 'post',
        route: 'events',
        data: {
          event,
        },
        showNotificationError: false,
      });

      if (PAGE_VIEW_EVENTS.includes(event)) {
        sessionStorage.setItem(`event_registered_${event}`, 'true');
      }

      return resp as IGetEventsResponse;
    } catch (error) {
      return [];
    }
  },

  getEvents: async (dispatch: Dispatch, params?: GetEventsParams) => {
    try {
      const resp = await execute({
        method: 'get',
        route: 'admin/legacy/events',
        params: params as Record<string, unknown>,
        showNotificationError: true,
        useAuthToken: true,
        dispatch,
      });

      return resp as IGetEventsResponse;
    } catch (error) {
      return null;
    }
  },

  downloadEventsExcel: async (params?: GetEventsParams) => {
    const queryParts: string[] = [];
    if (params?.fechaInicio) queryParts.push(`fechaInicio=${params.fechaInicio}`);
    if (params?.fechaFin) queryParts.push(`fechaFin=${params.fechaFin}`);
    if (params?.event) queryParts.push(`event=${params.event}`);
    const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';

    const response = await fetch(`/context/tescucha/api/v1/admin/legacy/events/report${queryString}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getFromLocalStorage(localStorageConstants.token)}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al descargar el reporte');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `TEscucha_reporte_${params?.fechaInicio}_${params?.fechaFin}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

export default analyticsService;
